module.exports = require("jsonwebtoken");


//////////////////
// WEBPACK FOOTER
// external "jsonwebtoken"
// module id = 15
// module chunks = 0